module.exports = __webpack_public_path__ + "img/ITM.050c0ff4.png";